import { pushEvent } from "helpers/utils/checkoutDataLayer";
import { events } from "constants/dataLayer";
import { PAGE_NAMES, PAGE_TYPES, TRACKING_EVENTS } from "constants/index";


const pageName = "savedAddressPage";

export const trackSavedAddressPageLoad = (params: any) => {
  const {
    addressCount,
    isGuest,
    isMobile,
    isFirstLandingPageAfterCheckout,
  } = params;
  pushEvent(events.SAVED_ADDRESS_PAGE_LOAD, {
    pageName,
    event: "savedAddressPageLoad",
    countOfSavedAddress: addressCount,
    loginStatus: isGuest ? "guest" : "logged in",
    page: PAGE_NAMES.SAVED_ADDRESS,
    page_type: PAGE_TYPES.ADDRESS_PAGE,
    address_view_location: isMobile ? PAGE_NAMES.SAVED_PAYMENT_PAGE : PAGE_NAMES.CART_PAGE,
    interaction_location: isMobile ? PAGE_NAMES.SAVED_PAYMENT_PAGE : PAGE_NAMES.CART_PAGE,
    is_logged_in: !isGuest,
    pageType: pageName,
    isFirstLandingPageAfterCheckout: isFirstLandingPageAfterCheckout,
  });
};

export const trackEditAddressPageLoad = () => {
  pushEvent(events.EDIT_ADDRESS_LOADS, {
  });
};

export const trackAddNewAddressClick = () => {
  pushEvent(events.ADD_NEW_ADDRESS_CLICK, {
    addressInteractions: "addNewAddress",
    page: PAGE_NAMES.ADD_NEW_ADDRESS,
    page_type: PAGE_TYPES.ADDRESS_PAGE,
    add_address_location: PAGE_NAMES.SAVED_ADDRESS,
    interaction_location: PAGE_NAMES.SAVED_ADDRESS,
  });
};

export const trackShipToThisAddressClick = (params: any) => {
  const {
    interactionLocation,
    isInputChanged,
  } = params;
  pushEvent(TRACKING_EVENTS.SHIP_TO_ADDRESS_CLICKS, {
    interactionLocation: interactionLocation,
    isInputChanged,
  });
};
